import {Form, Input} from 'antd';
import React, {ReactElement} from 'react';

import {DateCell} from 'components/table/columns/date-cell/date-cell';

import {IOrgInfoFormProps} from '../../../model/types';
import styles from './org-info-form.module.less';

export const OrgInfoForm = <T,>({fields, onFinish, formInstance}: IOrgInfoFormProps<T>): ReactElement => {
    const handleFinish = (values: T) => {
        onFinish?.(values);
    };

    return (
        <Form
            layout="vertical"
            form={formInstance}
            onFinish={handleFinish}
        >
            <section className="d-flex gap-2">
                <Form.Item
                    name="companyGroupCode"
                    label="Код группы компаний"
                    initialValue={fields?.companyGroupCode}
                    validateTrigger="onBlur"
                    rules={[{required: true}, {pattern: /^.{1,3}$/, message: 'Количество цифр должно быть от 1 до 3'}]}
                    className={styles['org-info-form__company-group-code--width']}
                >
                    <Input
                        onKeyPress={(e) => {
                            if (!/[0-9]/.test(e.key)) {
                                e.preventDefault();
                            }
                        }}
                    />
                </Form.Item>
                <Form.Item
                    name="inn"
                    label="ИНН организации"
                    initialValue={fields?.inn}
                    validateTrigger="onBlur"
                    rules={[{required: true}, {pattern: /^\d{10}$/, message: 'Количество цифр должно быть равным 10'}]}
                    className={styles['org-info-form__inn--width']}
                >
                    <Input
                        onKeyPress={(e) => {
                            if (!/[0-9]/.test(e.key)) {
                                e.preventDefault();
                            }
                        }}
                    />
                </Form.Item>
            </section>
            <section className="d-flex gap-2">
                <Form.Item
                    name="startDate"
                    label="Дата начала"
                    initialValue={fields?.startDate}
                    rules={[{required: true}]}
                    className={styles['org-info-form__start-date--width']}
                >
                    <DateCell format="DD.MM.YYYY" />
                </Form.Item>
                <Form.Item
                    name="endDate"
                    label="Дата окончания"
                    initialValue={fields?.endDate}
                    rules={[{required: true}]}
                    className={styles['org-info-form__end-date--width']}
                >
                    <DateCell format="DD.MM.YYYY" />
                </Form.Item>
            </section>
            <Form.Item
                name="id"
                initialValue={fields?.id}
                hidden
            />
        </Form>
    );
};
